<template>
  <main class="fixed inset-0 bg-gray-50 dark:bg-gray-900 grid place-items-center overflow-hidden p-4 sm:p-6">
    <div
        class="w-full max-w-lg bg-white dark:bg-gray-800 shadow-2xl rounded-2xl p-6 sm:p-8 text-center
             max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-3rem)] overflow-auto"
    >
      <div class="mb-6">
        <svg class="w-14 h-14 sm:w-16 sm:h-16 mx-auto" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" class="text-red-500" stroke-width="2"/>
          <path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" class="text-red-500" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>

      <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-3">
        {{ info.title || 'Account Terminated' }}
      </h1>

      <p class="text-gray-700 dark:text-gray-300 whitespace-pre-wrap mb-6">
        {{ info.reason || 'Your account has been disabled.' }}
      </p>

      <div v-if="info.banned_until" class="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Ban in effect until: <span class="font-semibold">{{ prettyDate(info.banned_until) }}</span>
      </div>

      <div class="space-y-2 mb-6">
        <a v-if="info.appeal_url"
           :href="info.appeal_url"
           class="inline-block px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700">
          Appeal
        </a>
        <a v-else
           :href="mailtoHref"
           class="inline-block px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700">
          Contact Support
        </a>
      </div>

      <button @click="logout" class="text-sm text-gray-500 dark:text-gray-400 underline">Return to login</button>
    </div>
  </main>
</template>

<script>
import { clearAuthToken, redirectToLogin as beginLogin } from '@/config/auth';
export default {
  name: 'BannedView',
  data() {
    return {
      info: {
        title: '',
        reason: '',
        banned_until: null,
        appeal_url: null,
        support_email: 'support@betterconnect.app'
      }
    }
  },
  computed: {
    mailtoHref() {
      const to = this.info.support_email || 'support@betterconnect.app';
      const subj = encodeURIComponent('BetterConnect – Account Appeal');
      const body = encodeURIComponent('Hello,\n\nI would like to appeal my account ban.\n\nThanks,');
      return `mailto:${to}?subject=${subj}&body=${body}`;
    }
  },
  methods: {
    prettyDate(iso) {
      const d = new Date(iso);
      if (isNaN(d)) return iso;
      return d.toLocaleString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    },
    logout() {
      clearAuthToken();
      localStorage.removeItem('banInfo');
      beginLogin({ originalUrl: window.location.origin });
    },
    tryLoadFromBt() {
      const bt = this.$route.query.bt;
      if (!bt) return false;
      try {
        const payload = JSON.parse(atob(bt.split('.')[1] || ''));
        if (payload && payload.b) {
          this.info = {...this.info, ...payload.b};
          return true;
        }
      } catch { /* ignore */
      }
      return false;
    }
  },
  created() {
    // 1) try URL token (bt) from /callback redirect
    const ok = this.tryLoadFromBt();
    if (ok) return;

    // 2) fallback: info saved by axios interceptor
    const cached = localStorage.getItem('banInfo');
    if (cached) {
      try {
        this.info = {...this.info, ...JSON.parse(cached)};
      } catch {
      }
    }
  }
}
</script>
